import { render, staticRenderFns } from "./OrderBook.vue?vue&type=template&id=1b1f8f42&scoped=true"
import script from "./OrderBook.vue?vue&type=script&lang=js"
export * from "./OrderBook.vue?vue&type=script&lang=js"
import style0 from "./OrderBook.vue?vue&type=style&index=0&id=1b1f8f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f8f42",
  null
  
)

export default component.exports